import { Component } from "react";
import { MDBRow, MDBCol } from "mdbreact";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bs-stepper/dist/css/bs-stepper.min.css";
import { toast } from "react-toastify";
//import messageService from "../messageService/messageService";
import SessionExpired from "../sessionExpire/SessionExpired";
import * as config from "../../config";
import "react-picky/dist/picky.css";

class DeviceOnBoarding extends Component<any, any> {
  stepper: any;
  statusSubscription: any;
  constructor(props: any) {
    super(props);
    this.state = {
      vin: props.editData?.vin || "",
      env: props.editData?.env || "tyau_sydney",
      status: props.editData?.status || "active",
      generation: props.editData?.generation || "24MM",
      envOptions: [
        "tyau_sydney",
        "cmau_sydney",
        "devna_virginia",
        "devna_oregon",
        "ppna_virginia",
        "ppna_oregon",
        "cmna_virginia",
        "tyin_mumbai",
        "tyeu_frankfurt",
      ],
      generationOptions: ["24MM", "26BEV"],
    };
  }
onboardCreate = () => {
  if (!this.state.vin || this.state.vin.length === 0) {
    console.error("Error: Vin is empty");
    toast.error("Vin cannot be empty");
    return;
  }

  let jsonData: any = {};
  jsonData.env = this.state.env;
  jsonData.vin = this.state.vin;
  jsonData.status = this.state.status;
  jsonData.generation = this.state.generation;

  const isEdit = this.props.editonBoard;
  const method = isEdit ? "PUT" : "POST";
  const url = config.rootUrl + "/v1/configuration/device";

  fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      "x-api-key": config.apiKey,
      Authorization: "Bearer " + this.props.jwtToken,
    },
    body: JSON.stringify(jsonData),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Server returned " + response.status);
      }
      return response.json();
    })
    .then((data) => {
      console.log("Success:", data);

      if (!isEdit) {
        toast.success("Device onboarded successfully!");
        fetch(config.rootUrl + "/v1/simulator/add-connection", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": config.apiKey,
            "x-environment": this.state.env,
            Authorization: "Bearer " + this.props.jwtToken,
          },
          body: JSON.stringify({ message: this.state.vin }),
        })
          .then((response) => response.json())
          .then((connData) => {
            console.log("Connection created:", connData);
            toast.success("MQTT connection established!");
          })
          .catch((connError) => {
            console.error("Connection creation failed:", connError);
            toast.warning("Device onboarded but connection failed.");
          });
      } else {
        toast.success("Device updated successfully!");
        if (this.props.closeMedal) {
          this.props.closeMedal();
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      toast.error("Server Error, Please Try Again Later..!");
    });
};

  changeHandler = (e: any) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  singleSelectdropdown = (data: any) => {
    this.setState({ [data.target.name]: data.target.value });
  };

  render() {
    console.log("Checking model", this.state.model);
    return (
      <Container fluid>
        {/* confirm if we are using this
        {this.state.sessionExpired && (
          <SessionExpired logout={this.props.logout} login={this.props.login} />
        )} */}
        {!this.props.editonBoard && (
          <h5 className="card-title font-weight-bold my-4">
            Device Onboarding
          </h5>
        )}

        <div className="card m-1">
          <div className="card-body">
            <MDBRow>
              <MDBCol size="6">
                <div className="form-group">
                  <label htmlFor="vin">VIN*</label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    id="vin"
                    placeholder="VIN"
                    value={this.state.vin}
                    onChange={this.changeHandler}
                    disabled={this.props.editonBoard === true}
                  />
                </div>
              </MDBCol>

              <MDBCol size="6">
                <div className="form-group dropdownArrowdown big">
                  <label htmlFor="env">ENV*</label>
                  <select
                    id="env"
                    name="env"
                    value={this.state.env}
                    onChange={this.singleSelectdropdown}
                    className="form-control"
                  >
                    {this.state.envOptions.map((data: any, index: number) => (
                      <option key={index} value={data}>
                        {data}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow>
              <MDBCol size="6">
                <div className="form-group dropdownArrowdown big">
                  <label htmlFor="generation">Generation*</label>
                  <select
                    id="generation"
                    name="generation"
                    value={this.state.generation}
                    onChange={this.singleSelectdropdown}
                    className="form-control"
                  >
                    {this.state.generationOptions.map((data: any, index: number) => (
                      <option key={index} value={data}>
                        {data}
                      </option>
                    ))}
                  </select>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-4">
              <MDBCol>
                <button
                  type="button"
                  onClick={this.onboardCreate}
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </MDBCol>
            </MDBRow>
          </div>
        </div>
      </Container>
    );
  }
}
export default DeviceOnBoarding;
